export enum BasketManagerTableComponent {
  Button = 'basket-manager-button',
  Collapse = 'basket-manager-collapse',
  DateTime = 'basket-manager-date-time',
  StatusBadge = 'basket-status-badge',
  User = 'basket-manager-user',
  OrderType = 'basket-manager-order-type',
  Checkbox = 'basket-manager-checkbox',
  Value = 'basket-manager-value',
  GenericCell = 'basket-manager-cell',
}

export enum BasketManagerFiltersComponent {
  AdvancedSelect = 'basket-manager-advanced-select',
  DatePicker = 'basket-manager-datepicker',
  SearchBar = 'basket-manager-search-bar',
  Select = 'basket-manager-select',
  UserSelect = 'basket-manager-user-select',
}
